import React from 'react';
import { useNavigate } from 'react-router-dom';

const OperacionesIndex = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-6xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Operaciones</h1>
      <p className="text-gray-600 text-sm mb-6">
        Inicia con el módulo de pedidos y luego pasa a la vista gráfica de mesas y barras.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <button
          type="button"
          onClick={() => navigate('/restaurantes/operaciones/pedidos')}
          className="text-left bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <div className="text-sm text-gray-500">Módulo</div>
          <div className="text-xl font-semibold text-teal-800 mt-1">Pedidos</div>
          <div className="text-sm text-gray-600 mt-2">Lista y acciones por zona.</div>
        </button>

        <button
          type="button"
          onClick={() => navigate('/restaurantes/operaciones/acceso')}
          className="text-left bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
        >
          <div className="text-sm text-gray-500">Acceso</div>
          <div className="text-xl font-semibold text-teal-800 mt-1">Mesas y barras</div>
          <div className="text-sm text-gray-600 mt-2">Acceso gráfico con datos demo.</div>
        </button>

        <button
          type="button"
          onClick={() => navigate('/restaurantes/operaciones/produccion')}
          className="text-left bg-white rounded-lg shadow-sm border border-gray-200 p-5 hover:border-teal-300 hover:bg-teal-50/50 transition-colors md:col-span-2 lg:col-span-1"
        >
          <div className="text-sm text-gray-500">Cocina</div>
          <div className="text-xl font-semibold text-teal-800 mt-1">Espacio de producción</div>
          <div className="text-sm text-gray-600 mt-2">Enviar a cocina, OP y entrega pendiente.</div>
        </button>
      </div>
    </div>
  );
};

export default OperacionesIndex;

